import React, { useRef, useState } from "react"


export default function FinancialChoice(props) {


const optionStyleTrue = {
    width: "90%",
    border: "1px solid #292929",
    margin: "10px auto 0 auto",
    color: "#292929",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#f1f1f1",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  const optionStyleFalse = {
    width: "90%",
    border: "1px solid #bbb",
    margin: "10px auto 0 auto",
    color: "#888",
    padding: "14px 8px",
    borderRadius: "5px",
    fontSize: "14px",
    fontWeight: "400",
    background: "#FFF",
    display: "flex",
    justifyContent: "space-between",
    cursor: "pointer",
  }

  let nameStyle = {
    margin: '0',
  }



    let rowStyle = {
        display: 'flex',
        // justifyContent: 'space-between',
        
    }
  
    let pLeftStyle = {
        width: '45%',
        textAlign: 'left',
        margin: '10px 10px 0px 20px',
        fontSize: '14px',
    }
    
    
    let pRightStyle = {
        width: '55%',
        textAlign: 'left',
        margin: '10px 10px 0px 10px',
        fontSize: '14px',
    }



    return (
      <>   

        {/* <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "640px",
            paddingTop: "56.25%", // 16:9 aspect ratio
            margin: "0 auto",
            
          }}
        >
          <iframe
            src={
              props.nearFarStandardMonofocal===true
              ? props.videosList.financialNoStandardSurgery
              : props.videosList.financialWithStandardSurgery
            }
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
              
            }}
            title="Refractive surgery"
            allowFullScreen
          />
        </div>             */}


        {/* Lens options */}

            <>



            <div
                style={{
                    // borderTop: '1px solid #292929',
                    // borderBottom: '1px solid #292929',
                    // background: '#',
                    margin: '0px 0 30px 0',
                    padding: '20px 0',
                    // borderRadius: '10px',
                }} 
            >
              <div style={rowStyle}>
                <p style={{
                  fontSize: '20px',
                  textAlign: 'center',
                  margin: '10px 10px 0 20px',
                  fontWeight: '600',
                }}>
                  {props.spanish === true ? "Costo adicional no cubierto" : "Additional out-of-pocket cost"}
                </p>
              </div>
                <div style={rowStyle}>
                  <p style={pLeftStyle}>
                      <span style={{fontWeight: '600'}}>
                        {props.spanish === true ? 'Opcion': 'Item'}
                      </span>
                  </p>
                  <p style={pRightStyle}>
                      <span style={{fontWeight: '600'}}>
                        {props.spanish === true ? 'Costo': 'Value'}
                      </span>
                  </p>
              </div>
                <div style={{
                    display: 'flex',
                    margin: '0px 0 0 0',
                }}>
                    <p style={pLeftStyle}>
                      {props.spanish === true ? 'Cirugía de catarata': 'Cataract surgery'}
                    </p>
                    <p style={pRightStyle}>{
                      props.lensOption === "Cataract vision"
                        ? ''
                        : props.spanish === true ? 'Cubierto por el seguro': 'Covered by insurance'}
                    </p>
                </div>
                <div style={rowStyle}>
                    <p style={pLeftStyle}>
                        {props.spanish === true ? 'Tarifa refractiva' : 'Flat refractive fee'}
                    </p>
                    <p style={pRightStyle}>{
                        props.lensOption === "Cataract vision"
                        ? ''
                        : props.refractive === true
                        ? `$${props.refractiveFee*1}`
                        : props.spanish === true ? 'Ninguna' : 'None'
                        }
                    </p>
                </div>
              
              <div style={rowStyle}>
                  <p style={pLeftStyle}>
                      {props.spanish === true ? 'Costo del lente' : 'Wholesale lens fee'}
                  </p>
                  <p style={pRightStyle}>{
                      props.lensOption === "Cataract vision"
                        ? ''
                        : props.refractive === true
                        ? `$${
                            props.lensHospitalFee === ''
                            ? 0
                            : props.lensHospitalFee
                          }`
                        : props.spanish === true ? 'Cubierto por el seguro': 'Covered by insurance'
                      }
                  </p>
              </div>

              <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <hr
                  style={{
                    width: '45%',
                    margin: '10px 10px 0px 20px',
                    border: '0',
                    height: '1px',
                    background: '#292929',
                    
                  }}
                />
                <hr
                  style={{
                    width: '55%',
                    margin: '10px 10px 0px 8px',
                    border: '0',
                    height: '1px',
                    background: '#292929',
                    
                  }}
                />
              </div>

              <div style={rowStyle}>
                  <p style={pLeftStyle}>
                      <span style={{fontWeight: '600'}}>
                        {props.spanish === true ? 'Total no cubierto por el seguro' : 'Total out-of-pocket'}
                      </span>
                  </p>
                  <p style={pRightStyle}>
                    <span style={{fontWeight: '600'}}>
                      {props.lensOption === "Cataract vision"
                        ? ''
                        : props.refractive === true
                        ? `$${props.lensHospitalFee*1 + props.refractiveFee*1}`
                        : props.spanish === true ? 'Cubierto por el seguro': 'Covered by insurance'
                      }
                    </span>    
                  </p>
              </div>
            </div>


            </>
      </>
    )
 
}







            // {
            //   props.nearFarStandardMonofocal === true ? null : 
            //     <div
            //       onClick={() => {
            //           props.setBestSelected(false)
            //           props.setMonofocalSelected(false)
            //           props.setRefractive(false)
            //           props.setLensOption(props.monofocalLens.lens_name)
            //           setAlertModal(true)
            //       }}
            //       style={
            //           props.refractive === true || props.lensOption === "Cataract vision"
            //           ? optionStyleFalse
            //           : optionStyleTrue
            //         }
            //     >
            //         <div
            //             style={{
            //                 display: 'flex',
            //                 justifyContent: 'space-between',
            //                 width: '100%',
            //             }}
            //         >
            //             <p style={nameStyle}> 
            //                 {props.spanish === true ? 'Usa gafas todo el tiempo': 'Wear glasses full time after surgery'}
            //             </p>
            //             {/* <p style={nameStyle}>
            //                 {props.spanish === true ? '(sin cirugía refractiva)' : '(no refractive surgery)'}
            //             </p> */}
            //         </div>
                    
            //     </div>
            //   }

